module.exports = __webpack_public_path__ + "img/genstation-enter.f09d4ba1.png";